export const environmentRecipeUiMetadata = {
  ithor_kitchen_floorplan1: {
    groupId: "environment_demos",
    groupLabel: "Environment Demos",
    scenarioId: "ithor_kitchen_floorplan1",
    scenarioLabel: "iTHOR Kitchen",
  },
};

export const environmentRecipes = [
  {
    id: "ithor_kitchen_floorplan1",
    label: "iTHOR Kitchen (FloorPlan1)",
    kind: "externalXml",
    xmlPath: "/s1/FloorPlan1_physics.xml",
    xmlFilename: "FloorPlan1_physics.xml",
    worldBodyNameBase: "iTHOR FloorPlan1",
  },
];
